<div class="flex flex-direction--row flex-gap-16-8 align-items-center">
  @if (isInitializing) {
    <shared-local-dot-loader />
  } @else if (filterDefinition$ | async; as filterDefinition) {
    @for (filter of filterDefinition.filters; track filter.name) {
      @if (filter.type === FilterItemType.Select || filter.type === FilterItemType.MultiSelect) {
        <div class="select-content-width">
          @let map = filterSelectionMap.get(filter.name);
          <shared-select-with-search
            selectClass="pointee-mat-select"
            [attr.data-testid]="'filter-' + filter.name + '-select'"
            [multiple]="filter.type === FilterItemType.MultiSelect"
            [items]="map.items"
            [fixedItems]="map.fixedItems"
            [selectAllLabel]="map.selectAllLabel"
            [selection]="map.selection"
            [defaultValue]="map.defaultValue"
            [placeholder]="filter.placeholder"
            [disabled]="disabled"
            [sortItemsByLabel]="map.sortItemsByLabel ?? true"
            (selectionChange)="onFilterValueChanged($event, filter)"
            (selectionEnd)="onFilterClosed($event, filter)"
          />
        </div>
        @if (filter.getTooltip) {
          <ng-container *ngrxLet="filter.getTooltip() as tooltipMsg">
            @if (tooltipMsg) {
              <span class="filter-info">
                <shared-info-icon [tooltip]="tooltipMsg" />
              </span>
            }
          </ng-container>
        }
      }
      @if (filter.type === FilterItemType.Checkbox) {
        <mat-checkbox
          [attr.data-testid]="'filter-' + filter.name + '-checkbox'"
          [checked]="filter.value"
          [disabled]="disabled"
          (change)="onCheckboxChanged($event.checked, filter)">
          {{ filter.label }}
        </mat-checkbox>
      }
    }
    @if (canClearAllFilters()) {
      <button id="clear-filters-btn" class="btn btn-link" (click)="clearFilters()"><svg-icon key="close" [fontSize]="10" /><b>Clear filters</b></button>
    }
  }
</div>

@if (showSearch && !displaySearchInput) {
  <button data-testid="open-search-button" class="ghost-btn" (click)="toggleSearch()"><svg-icon key="search" />Search...</button>
}
@if (showSearch && displaySearchInput) {
  <shared-search-input
    [searchValue]="searchValue"
    [closeAlwaysVisible]="true"
    [placeholder]="searchPlaceholder"
    (searchValueChange)="onSearchValueChange($event)"
    (clear)="displaySearchInput = false"
  />
}
